<template>
    <span>
        {{ user.name }}
    </span>
</template>

<script>
export default {
    props: {
        id: [String, Number],
        data: Object
    },
    data() {
        return {user: {}}
    },
    methods: {
        loadUserById() {
            this.$api.get(`/users/${this.id}`)
                .then(res => this.user = res.data)
                .catch(err => this.handleError(err))
        }
    },
    watch: {
        id: {
            handler(newVal) {
                if (newVal)
                    this.loadUserById()
            },
            immediate: true
        },
        data: {
            handler(newVal) {
                if (newVal)
                    this.user = newVal
            },
            immediate: true
        }
    }
}
</script>
